// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/icon-bird.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg height=%2710px%27 width=%2720px%27 viewBox=%270 0 16 16%27 fill=%27%232f318d%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-container .button {
  margin-right: 1rem;
}

.button {
  background-color: var(--tint-color);
  padding: 2rem 2rem;
  border-radius: 2.5rem;
  border-width: 0.25rem;
  border-color: var(--tint-color);
  border-style: solid;
  height: 5rem;
  font-size: 2rem;
  align-items: center;
  justify-content: center;
  display: flex;
  color: var(--light-color);
  flex-shrink: 1;
  white-space: nowrap;
}

.button-icon {
  width: 22px;
  height: 22px;
  margin-right: 1rem;
}

.button-icon.icon-home {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.button:not(.disabled):active {
  transform: scale(0.96) !important;
}

.button:not(.disabled):hover {
  transform: scale(1.04);
  background-color: var(--tint-color-light);
  color: var(--tint-color);
  cursor: pointer;
}

.button.button__secondary:not(.disabled):hover {
  border-color: var(--tint-color);
}

.button.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.button.button__round {
  width: 5rem;
  padding: 0;
}

.button.button__round.button__mini {
  width: 3rem;
}

.button.button__mini {
  height: 3rem;
  padding: 1rem;
  font-size: 1.5rem;
}

.button.button__secondary {
  background-color: var(--tint-color-light);
  color: var(--tint-color);
  border-color: transparent;
}



select.button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance:none;
  outline: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: calc(100% - 0.75rem) center !important;
  background-repeat: no-repeat;
  padding-right: 4rem;
}

select.button.button__theme-rackare-a {
  background-image: var(--rackare-select-arrow-background-a-url);
}

select.button.button__theme-rackare-a:hover {
  background-image: var(--rackare-select-arrow-foreground-a-url);
}

select.button.button__theme-rackare-b {
  background-image: var(--rackare-select-arrow-background-b-url);
}

select.button.button__theme-rackare-b:hover {
  background-image: var(--rackare-select-arrow-foreground-b-url);
}

select.button.button__theme-rackare-b.inverted {
  background-image: var(--rackare-select-arrow-foreground-b-url);
}

select.button.button__theme-rackare-b.inverted:hover {
  background-image: var(--rackare-select-arrow-background-b-url);
}

select.button.button__secondary.button__theme-rackare-a {
  background-image: var(--rackare-select-arrow-foreground-a-url);
}

select.button.button__secondary.button__theme-rackare-a:hover {
  background-image: var(--rackare-select-arrow-foreground-a-url);
}

select.button.button__secondary.button__theme-rackare-b {
  background-image: var(--rackare-select-arrow-foreground-b-url);
}

select.button.button__secondary.button__theme-rackare-b:hover {
  background-image: var(--rackare-select-arrow-foreground-b-url);
}

select.button.button__secondary.button__theme-rackare-b.inverted {
  background-image: var(--rackare-select-arrow-background-b-url);
}

select.button.button__secondary.button__theme-rackare-b.inverted:hover {
  background-image: var(--rackare-select-arrow-background-b-url);
}



select.button.button__theme-swipe-a {
  background-image: var(--swipe-select-arrow-background-a-url);
}

select.button.button__theme-swipe-a:hover {
  background-image: var(--swipe-select-arrow-foreground-a-url);
}

select.button.button__theme-swipe-b {
  background-image: var(--swipe-select-arrow-background-b-url);
}

select.button.button__theme-swipe-b:hover {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}

select.button.button__theme-swipe-b.inverted {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}

select.button.button__theme-swipe-b.inverted:hover {
  background-image: var(--swipe-select-arrow-background-b-url);
}

select.button.button__secondary.button__theme-swipe-a {
  background-image: var(--swipe-select-arrow-foreground-a-url);
}

select.button.button__secondary.button__theme-swipe-a:hover {
  background-image: var(--swipe-select-arrow-foreground-a-url);
}

select.button.button__secondary.button__theme-swipe-b {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}

select.button.button__secondary.button__theme-swipe-b:hover {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}

select.button.button__secondary.button__theme-swipe-b.inverted {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}

select.button.button__secondary.button__theme-swipe-b.inverted:hover {
  background-image: var(--swipe-select-arrow-foreground-b-url);
}



select.button {
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
}



.button.button__mono.mono-light {
  background-color: var(--mono-light-background-color);
  border-color: var(--mono-light-background-color);
  color: var(--mono-light-foreground-color);
}

.button.button__mono.mono-light:hover {
  background-color: var(--mono-dark-background-color);
  border-color: var(--mono-dark-foreground-color);
  color: var(--mono-dark-foreground-color);
}

.button.button__mono.mono-dark {
  background-color: var(--mono-dark-background-color);
  border-color: var(--mono-dark-background-color);
  color: var(--mono-dark-foreground-color);
}

.button.button__mono.mono-dark:hover {
  background-color: var(--mono-light-background-color);
  border-color: var(--mono-light-foreground-color);
  color: var(--mono-light-foreground-color);
}



.button.button__secondary.button__theme-swipe-a {
  background-color: var(--swipe-background-a-color);
  border-color: var(--swipe-background-a-color);
  color: var(--swipe-foreground-a-color);
}

.button.button__secondary.button__theme-swipe-a:hover {
  background-color: var(--swipe-background-a-color);
  border-color: var(--swipe-foreground-a-color);
  color: var(--swipe-foreground-a-color);
}

.button.button__secondary.button__theme-swipe-b {
  background-color: var(--swipe-background-b-color);
  border-color: var(--swipe-background-b-color);
  color: var(--swipe-foreground-b-color);
}

.button.button__secondary.button__theme-swipe-b:hover {
  background-color: var(--swipe-background-b-color);
  border-color: var(--swipe-foreground-b-color);
  color: var(--swipe-foreground-b-color);
}

.button.button__secondary.button__theme-swipe-b.inverted {
  background-color: var(--swipe-foreground-b-color);
  border-color: var(--swipe-foreground-b-color);
  color: var(--swipe-background-b-color);
}

.button.button__secondary.button__theme-swipe-b.inverted:hover {
  background-color: var(--swipe-foreground-b-color);
  border-color: var(--swipe-background-b-color);
  color: var(--swipe-background-b-color);
}



.button.button__secondary.button__theme-rackare-a {
  background-color: var(--rackare-background-a-color);
  border-color: var(--rackare-background-a-color);
  color: var(--rackare-foreground-a-color);
}

.button.button__secondary.button__theme-rackare-a:hover {
  background-color: var(--rackare-background-a-color);
  border-color: var(--rackare-foreground-a-color);
  color: var(--rackare-foreground-a-color);
}

.button.button__secondary.button__theme-rackare-b {
  background-color: var(--rackare-background-b-color);
  border-color: var(--rackare-background-b-color);
  color: var(--rackare-foreground-b-color);
}

.button.button__secondary.button__theme-rackare-b:hover {
  background-color: var(--rackare-background-b-color);
  border-color: var(--rackare-foreground-b-color);
  color: var(--rackare-foreground-b-color);
}

.button.button__secondary.button__theme-rackare-b.inverted {
  background-color: var(--rackare-foreground-b-color);
  border-color: var(--rackare-foreground-b-color);
  color: var(--rackare-background-b-color);
}

.button.button__secondary.button__theme-rackare-b.inverted:hover {
  background-color: var(--rackare-foreground-b-color);
  border-color: var(--rackare-background-b-color);
  color: var(--rackare-background-b-color);
}



.button.button__theme-swipe-a {
  background-color: var(--swipe-foreground-a-color);
  border-color: var(--swipe-foreground-a-color);
  color: var(--swipe-background-a-color);
}

.button.button__theme-swipe-a:hover {
  background-color: var(--swipe-background-a-color);
  color: var(--swipe-foreground-a-color);
}

.button.button__theme-swipe-b {
  background-color: var(--swipe-foreground-b-color);
  border-color: var(--swipe-foreground-b-color);
  color: var(--swipe-background-b-color);
}

.button.button__theme-swipe-b:hover {
  background-color: var(--swipe-background-b-color);
  color: var(--swipe-foreground-b-color);
}

.button.button__theme-swipe-b.inverted {
  background-color: var(--swipe-background-b-color);
  border-color: var(--swipe-background-b-color);
  color: var(--swipe-foreground-b-color);
}

.button.button__theme-swipe-b.inverted:hover {
  background-color: var(--swipe-foreground-b-color);
  color: var(--swipe-background-b-color);
}



.button.button__theme-rackare-a {
  background-color: var(--rackare-foreground-a-color);
  border-color: var(--rackare-foreground-a-color);
  color: var(--rackare-background-a-color);
}

.button.button__theme-rackare-a:hover {
  background-color: var(--rackare-background-a-color);
  color: var(--rackare-foreground-a-color);
}

.button.button__theme-rackare-b {
  background-color: var(--rackare-foreground-b-color);
  border-color: var(--rackare-foreground-b-color);
  color: var(--rackare-background-b-color);
}

.button.button__theme-rackare-b:hover {
  background-color: var(--rackare-background-b-color);
  color: var(--rackare-foreground-b-color);
}

.button.button__theme-rackare-b.inverted {
  background-color: var(--rackare-background-b-color);
  border-color: var(--rackare-background-b-color);
  color: var(--rackare-foreground-b-color);
}

.button.button__theme-rackare-b.inverted:hover {
  background-color: var(--rackare-foreground-b-color);
  color: var(--rackare-background-b-color);
}



.card-backface--add-button.button.button__theme-swipe-a {
  border-color: var(--swipe-background-a-color);
}

.card-backface--add-button.button.button__theme-swipe-a:hover {
  border-color: var(--swipe-foreground-a-color);
}

.card-backface--add-button.button.button__theme-swipe-b {
  border-color: var(--swipe-background-b-color);
}

.card-backface--add-button.button.button__theme-swipe-b:hover {
  border-color: var(--swipe-foreground-b-color);
}

.card-backface--add-button.button.button__theme-swipe-b.inverted {
  border-color: var(--swipe-foreground-b-color);
}

.card-backface--add-button.button.button__theme-swipe-b.inverted:hover {
  border-color: var(--swipe-background-b-color);
}



.card-backface--add-button.button.button__theme-rackare-a {
  border-color: var(--rackare-background-a-color);
}

.card-backface--add-button.button.button__theme-rackare-a:hover {
  border-color: var(--rackare-foreground-a-color);
}

.card-backface--add-button.button.button__theme-rackare-b {
  border-color: var(--rackare-background-b-color);
}

.card-backface--add-button.button.button__theme-rackare-b:hover {
  border-color: var(--rackare-foreground-b-color);
}

.card-backface--add-button.button.button__theme-rackare-b.inverted {
  border-color: var(--rackare-foreground-b-color);
}

.card-backface--add-button.button.button__theme-rackare-b.inverted:hover {
  border-color: var(--rackare-background-b-color);
}



.button.switch-button {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: var(--tint-color-light);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0;
  padding-bottom: 0;
}

.button .switch-button--content {
  display: flex;
}

.button.switch-button .switch-button-item.selected {
  background-color: var(--tint-color);
  color: #ffffff;
}

.button.switch-button .switch-button-item {
  display: flex;
  background-color: transparent;
  color: var(--tint-color);
  border-radius: 2rem;
  z-index: 1;
  text-align: center;
}

.button.switch-button .switch-button-item:not(.selected):hover {
  background-color: var(--tint-color);
  color: #ffffff;
}

.button .switch-button--content:hover .switch-button-item:not(:hover) {
  background-color: transparent;
  color: var(--tint-color);
  border-radius: 2rem;
}

.button.switch-button .switch-button-slider {
  position: absolute;
  left: 0%;
  width: 50%;
  height: 100%;
  z-index: 0;
  border-radius: 2rem;
}

.switch-button .switch-button-item:first-of-type {
  margin-right: 0.25rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

.switch-button .switch-button-item:first-of-type:hover {
  padding-right: 2rem;
}

.switch-button .switch-button-item:last-of-type {
  margin-left: 0.25rem;
  padding-right: 2rem;
  padding-left: 2rem;
}

.switch-button .switch-button-item:last-of-type:hover {
  padding-left: 2rem;
}



.button.button__theme-swipe-a.switch-button {
  background-color: var(--swipe-background-a-color);
}

.button.button__theme-swipe-a.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-swipe-a.switch-button .switch-button-item.selected {
  background-color: var(--swipe-foreground-a-color);
  color: var(--swipe-background-a-color);
}

.button.button__theme-swipe-a .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-swipe-a.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--swipe-foreground-a-color);
}



.button.button__theme-swipe-b.switch-button {
  background-color: var(--swipe-background-b-color);
}

.button.button__theme-swipe-b.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-swipe-b.switch-button .switch-button-item.selected {
  background-color: var(--swipe-foreground-b-color);
  color: var(--swipe-background-b-color);
}

.button.button__theme-swipe-b .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-swipe-b.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--swipe-foreground-b-color);
}

.button.button__theme-swipe-b.inverted.switch-button {
  background-color: var(--swipe-foreground-b-color);
}

.button.button__theme-swipe-b.inverted.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-swipe-b.inverted.switch-button .switch-button-item.selected {
  background-color: var(--swipe-background-b-color);
  color: var(--swipe-foreground-b-color);
}

.button.button__theme-swipe-b.inverted .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-swipe-b.inverted.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--swipe-background-b-color);
}



.button.button__theme-rackare-a.switch-button {
  background-color: var(--rackare-background-a-color);
}

.button.button__theme-rackare-a.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-rackare-a.switch-button .switch-button-item.selected {
  background-color: var(--rackare-foreground-a-color);
  color: var(--rackare-background-a-color);
}

.button.button__theme-rackare-a .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-rackare-a.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--rackare-foreground-a-color);
}



.button.button__theme-rackare-b.switch-button {
  background-color: var(--rackare-background-b-color);
}

.button.button__theme-rackare-b.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-rackare-b.switch-button .switch-button-item.selected {
  background-color: var(--rackare-foreground-b-color);
  color: var(--rackare-background-b-color);
}

.button.button__theme-rackare-b .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-rackare-b.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--rackare-foreground-b-color);
}


.button.button__theme-rackare-b.inverted.switch-button {
  background-color: var(--rackare-foreground-b-color);
}

.button.button__theme-rackare-b.inverted.switch-button .switch-button-item:not(.selected):hover,
.button.button__theme-rackare-b.inverted.switch-button .switch-button-item.selected {
  background-color: var(--rackare-background-b-color);
  color: var(--rackare-foreground-b-color);
}

.button.button__theme-rackare-b.inverted .switch-button--content:hover .switch-button-item:not(:hover),
.button.button__theme-rackare-b.inverted.switch-button .switch-button-item {
  background-color: transparent;
  color: var(--rackare-background-b-color);
}`, "",{"version":3,"sources":["webpack://./src/button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,yBAAyB;AAC3B;;;;AAIA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,yDAAoR;EACpR,2DAA2D;EAC3D,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;AAChE;;;;AAIA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;;;AAIA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,yCAAyC;AAC3C;;;;AAIA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;;;AAIA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;;;AAIA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;;;AAIA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,mDAAmD;EACnD,wCAAwC;AAC1C;;;;AAIA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;;;AAIA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;;;AAIA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;EAC7B,sCAAsC;AACxC;;;;AAIA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;;EAEE,6BAA6B;EAC7B,sCAAsC;AACxC;;;;AAIA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;;EAEE,6BAA6B;EAC7B,wCAAwC;AAC1C;;;;AAIA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;;EAEE,6BAA6B;EAC7B,wCAAwC;AAC1C;;;AAGA;EACE,mDAAmD;AACrD;;AAEA;;EAEE,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;;EAEE,6BAA6B;EAC7B,wCAAwC;AAC1C","sourcesContent":[".button-container .button {\n  margin-right: 1rem;\n}\n\n.button {\n  background-color: var(--tint-color);\n  padding: 2rem 2rem;\n  border-radius: 2.5rem;\n  border-width: 0.25rem;\n  border-color: var(--tint-color);\n  border-style: solid;\n  height: 5rem;\n  font-size: 2rem;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  color: var(--light-color);\n  flex-shrink: 1;\n  white-space: nowrap;\n}\n\n.button-icon {\n  width: 22px;\n  height: 22px;\n  margin-right: 1rem;\n}\n\n.button-icon.icon-home {\n  background-image: url(\"../public/icon-bird.svg\");\n  background-size: cover;\n}\n\n.button:not(.disabled):active {\n  transform: scale(0.96) !important;\n}\n\n.button:not(.disabled):hover {\n  transform: scale(1.04);\n  background-color: var(--tint-color-light);\n  color: var(--tint-color);\n  cursor: pointer;\n}\n\n.button.button__secondary:not(.disabled):hover {\n  border-color: var(--tint-color);\n}\n\n.button.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.button.button__round {\n  width: 5rem;\n  padding: 0;\n}\n\n.button.button__round.button__mini {\n  width: 3rem;\n}\n\n.button.button__mini {\n  height: 3rem;\n  padding: 1rem;\n  font-size: 1.5rem;\n}\n\n.button.button__secondary {\n  background-color: var(--tint-color-light);\n  color: var(--tint-color);\n  border-color: transparent;\n}\n\n\n\nselect.button {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance:none;\n  outline: none;\n  background-image: url(\"data:image/svg+xml,<svg height='10px' width='20px' viewBox='0 0 16 16' fill='%232f318d' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>\");\n  background-position: calc(100% - 0.75rem) center !important;\n  background-repeat: no-repeat;\n  padding-right: 4rem;\n}\n\nselect.button.button__theme-rackare-a {\n  background-image: var(--rackare-select-arrow-background-a-url);\n}\n\nselect.button.button__theme-rackare-a:hover {\n  background-image: var(--rackare-select-arrow-foreground-a-url);\n}\n\nselect.button.button__theme-rackare-b {\n  background-image: var(--rackare-select-arrow-background-b-url);\n}\n\nselect.button.button__theme-rackare-b:hover {\n  background-image: var(--rackare-select-arrow-foreground-b-url);\n}\n\nselect.button.button__theme-rackare-b.inverted {\n  background-image: var(--rackare-select-arrow-foreground-b-url);\n}\n\nselect.button.button__theme-rackare-b.inverted:hover {\n  background-image: var(--rackare-select-arrow-background-b-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-a {\n  background-image: var(--rackare-select-arrow-foreground-a-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-a:hover {\n  background-image: var(--rackare-select-arrow-foreground-a-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-b {\n  background-image: var(--rackare-select-arrow-foreground-b-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-b:hover {\n  background-image: var(--rackare-select-arrow-foreground-b-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-b.inverted {\n  background-image: var(--rackare-select-arrow-background-b-url);\n}\n\nselect.button.button__secondary.button__theme-rackare-b.inverted:hover {\n  background-image: var(--rackare-select-arrow-background-b-url);\n}\n\n\n\nselect.button.button__theme-swipe-a {\n  background-image: var(--swipe-select-arrow-background-a-url);\n}\n\nselect.button.button__theme-swipe-a:hover {\n  background-image: var(--swipe-select-arrow-foreground-a-url);\n}\n\nselect.button.button__theme-swipe-b {\n  background-image: var(--swipe-select-arrow-background-b-url);\n}\n\nselect.button.button__theme-swipe-b:hover {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\nselect.button.button__theme-swipe-b.inverted {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\nselect.button.button__theme-swipe-b.inverted:hover {\n  background-image: var(--swipe-select-arrow-background-b-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-a {\n  background-image: var(--swipe-select-arrow-foreground-a-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-a:hover {\n  background-image: var(--swipe-select-arrow-foreground-a-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-b {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-b:hover {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-b.inverted {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\nselect.button.button__secondary.button__theme-swipe-b.inverted:hover {\n  background-image: var(--swipe-select-arrow-foreground-b-url);\n}\n\n\n\nselect.button {\n  padding-top: 0;\n  padding-bottom: 0;\n  text-align: center;\n}\n\n\n\n.button.button__mono.mono-light {\n  background-color: var(--mono-light-background-color);\n  border-color: var(--mono-light-background-color);\n  color: var(--mono-light-foreground-color);\n}\n\n.button.button__mono.mono-light:hover {\n  background-color: var(--mono-dark-background-color);\n  border-color: var(--mono-dark-foreground-color);\n  color: var(--mono-dark-foreground-color);\n}\n\n.button.button__mono.mono-dark {\n  background-color: var(--mono-dark-background-color);\n  border-color: var(--mono-dark-background-color);\n  color: var(--mono-dark-foreground-color);\n}\n\n.button.button__mono.mono-dark:hover {\n  background-color: var(--mono-light-background-color);\n  border-color: var(--mono-light-foreground-color);\n  color: var(--mono-light-foreground-color);\n}\n\n\n\n.button.button__secondary.button__theme-swipe-a {\n  background-color: var(--swipe-background-a-color);\n  border-color: var(--swipe-background-a-color);\n  color: var(--swipe-foreground-a-color);\n}\n\n.button.button__secondary.button__theme-swipe-a:hover {\n  background-color: var(--swipe-background-a-color);\n  border-color: var(--swipe-foreground-a-color);\n  color: var(--swipe-foreground-a-color);\n}\n\n.button.button__secondary.button__theme-swipe-b {\n  background-color: var(--swipe-background-b-color);\n  border-color: var(--swipe-background-b-color);\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__secondary.button__theme-swipe-b:hover {\n  background-color: var(--swipe-background-b-color);\n  border-color: var(--swipe-foreground-b-color);\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__secondary.button__theme-swipe-b.inverted {\n  background-color: var(--swipe-foreground-b-color);\n  border-color: var(--swipe-foreground-b-color);\n  color: var(--swipe-background-b-color);\n}\n\n.button.button__secondary.button__theme-swipe-b.inverted:hover {\n  background-color: var(--swipe-foreground-b-color);\n  border-color: var(--swipe-background-b-color);\n  color: var(--swipe-background-b-color);\n}\n\n\n\n.button.button__secondary.button__theme-rackare-a {\n  background-color: var(--rackare-background-a-color);\n  border-color: var(--rackare-background-a-color);\n  color: var(--rackare-foreground-a-color);\n}\n\n.button.button__secondary.button__theme-rackare-a:hover {\n  background-color: var(--rackare-background-a-color);\n  border-color: var(--rackare-foreground-a-color);\n  color: var(--rackare-foreground-a-color);\n}\n\n.button.button__secondary.button__theme-rackare-b {\n  background-color: var(--rackare-background-b-color);\n  border-color: var(--rackare-background-b-color);\n  color: var(--rackare-foreground-b-color);\n}\n\n.button.button__secondary.button__theme-rackare-b:hover {\n  background-color: var(--rackare-background-b-color);\n  border-color: var(--rackare-foreground-b-color);\n  color: var(--rackare-foreground-b-color);\n}\n\n.button.button__secondary.button__theme-rackare-b.inverted {\n  background-color: var(--rackare-foreground-b-color);\n  border-color: var(--rackare-foreground-b-color);\n  color: var(--rackare-background-b-color);\n}\n\n.button.button__secondary.button__theme-rackare-b.inverted:hover {\n  background-color: var(--rackare-foreground-b-color);\n  border-color: var(--rackare-background-b-color);\n  color: var(--rackare-background-b-color);\n}\n\n\n\n.button.button__theme-swipe-a {\n  background-color: var(--swipe-foreground-a-color);\n  border-color: var(--swipe-foreground-a-color);\n  color: var(--swipe-background-a-color);\n}\n\n.button.button__theme-swipe-a:hover {\n  background-color: var(--swipe-background-a-color);\n  color: var(--swipe-foreground-a-color);\n}\n\n.button.button__theme-swipe-b {\n  background-color: var(--swipe-foreground-b-color);\n  border-color: var(--swipe-foreground-b-color);\n  color: var(--swipe-background-b-color);\n}\n\n.button.button__theme-swipe-b:hover {\n  background-color: var(--swipe-background-b-color);\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__theme-swipe-b.inverted {\n  background-color: var(--swipe-background-b-color);\n  border-color: var(--swipe-background-b-color);\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__theme-swipe-b.inverted:hover {\n  background-color: var(--swipe-foreground-b-color);\n  color: var(--swipe-background-b-color);\n}\n\n\n\n.button.button__theme-rackare-a {\n  background-color: var(--rackare-foreground-a-color);\n  border-color: var(--rackare-foreground-a-color);\n  color: var(--rackare-background-a-color);\n}\n\n.button.button__theme-rackare-a:hover {\n  background-color: var(--rackare-background-a-color);\n  color: var(--rackare-foreground-a-color);\n}\n\n.button.button__theme-rackare-b {\n  background-color: var(--rackare-foreground-b-color);\n  border-color: var(--rackare-foreground-b-color);\n  color: var(--rackare-background-b-color);\n}\n\n.button.button__theme-rackare-b:hover {\n  background-color: var(--rackare-background-b-color);\n  color: var(--rackare-foreground-b-color);\n}\n\n.button.button__theme-rackare-b.inverted {\n  background-color: var(--rackare-background-b-color);\n  border-color: var(--rackare-background-b-color);\n  color: var(--rackare-foreground-b-color);\n}\n\n.button.button__theme-rackare-b.inverted:hover {\n  background-color: var(--rackare-foreground-b-color);\n  color: var(--rackare-background-b-color);\n}\n\n\n\n.card-backface--add-button.button.button__theme-swipe-a {\n  border-color: var(--swipe-background-a-color);\n}\n\n.card-backface--add-button.button.button__theme-swipe-a:hover {\n  border-color: var(--swipe-foreground-a-color);\n}\n\n.card-backface--add-button.button.button__theme-swipe-b {\n  border-color: var(--swipe-background-b-color);\n}\n\n.card-backface--add-button.button.button__theme-swipe-b:hover {\n  border-color: var(--swipe-foreground-b-color);\n}\n\n.card-backface--add-button.button.button__theme-swipe-b.inverted {\n  border-color: var(--swipe-foreground-b-color);\n}\n\n.card-backface--add-button.button.button__theme-swipe-b.inverted:hover {\n  border-color: var(--swipe-background-b-color);\n}\n\n\n\n.card-backface--add-button.button.button__theme-rackare-a {\n  border-color: var(--rackare-background-a-color);\n}\n\n.card-backface--add-button.button.button__theme-rackare-a:hover {\n  border-color: var(--rackare-foreground-a-color);\n}\n\n.card-backface--add-button.button.button__theme-rackare-b {\n  border-color: var(--rackare-background-b-color);\n}\n\n.card-backface--add-button.button.button__theme-rackare-b:hover {\n  border-color: var(--rackare-foreground-b-color);\n}\n\n.card-backface--add-button.button.button__theme-rackare-b.inverted {\n  border-color: var(--rackare-foreground-b-color);\n}\n\n.card-backface--add-button.button.button__theme-rackare-b.inverted:hover {\n  border-color: var(--rackare-background-b-color);\n}\n\n\n\n.button.switch-button {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--tint-color-light);\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.button .switch-button--content {\n  display: flex;\n}\n\n.button.switch-button .switch-button-item.selected {\n  background-color: var(--tint-color);\n  color: #ffffff;\n}\n\n.button.switch-button .switch-button-item {\n  display: flex;\n  background-color: transparent;\n  color: var(--tint-color);\n  border-radius: 2rem;\n  z-index: 1;\n  text-align: center;\n}\n\n.button.switch-button .switch-button-item:not(.selected):hover {\n  background-color: var(--tint-color);\n  color: #ffffff;\n}\n\n.button .switch-button--content:hover .switch-button-item:not(:hover) {\n  background-color: transparent;\n  color: var(--tint-color);\n  border-radius: 2rem;\n}\n\n.button.switch-button .switch-button-slider {\n  position: absolute;\n  left: 0%;\n  width: 50%;\n  height: 100%;\n  z-index: 0;\n  border-radius: 2rem;\n}\n\n.switch-button .switch-button-item:first-of-type {\n  margin-right: 0.25rem;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.switch-button .switch-button-item:first-of-type:hover {\n  padding-right: 2rem;\n}\n\n.switch-button .switch-button-item:last-of-type {\n  margin-left: 0.25rem;\n  padding-right: 2rem;\n  padding-left: 2rem;\n}\n\n.switch-button .switch-button-item:last-of-type:hover {\n  padding-left: 2rem;\n}\n\n\n\n.button.button__theme-swipe-a.switch-button {\n  background-color: var(--swipe-background-a-color);\n}\n\n.button.button__theme-swipe-a.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-swipe-a.switch-button .switch-button-item.selected {\n  background-color: var(--swipe-foreground-a-color);\n  color: var(--swipe-background-a-color);\n}\n\n.button.button__theme-swipe-a .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-swipe-a.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--swipe-foreground-a-color);\n}\n\n\n\n.button.button__theme-swipe-b.switch-button {\n  background-color: var(--swipe-background-b-color);\n}\n\n.button.button__theme-swipe-b.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-swipe-b.switch-button .switch-button-item.selected {\n  background-color: var(--swipe-foreground-b-color);\n  color: var(--swipe-background-b-color);\n}\n\n.button.button__theme-swipe-b .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-swipe-b.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__theme-swipe-b.inverted.switch-button {\n  background-color: var(--swipe-foreground-b-color);\n}\n\n.button.button__theme-swipe-b.inverted.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-swipe-b.inverted.switch-button .switch-button-item.selected {\n  background-color: var(--swipe-background-b-color);\n  color: var(--swipe-foreground-b-color);\n}\n\n.button.button__theme-swipe-b.inverted .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-swipe-b.inverted.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--swipe-background-b-color);\n}\n\n\n\n.button.button__theme-rackare-a.switch-button {\n  background-color: var(--rackare-background-a-color);\n}\n\n.button.button__theme-rackare-a.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-rackare-a.switch-button .switch-button-item.selected {\n  background-color: var(--rackare-foreground-a-color);\n  color: var(--rackare-background-a-color);\n}\n\n.button.button__theme-rackare-a .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-rackare-a.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--rackare-foreground-a-color);\n}\n\n\n\n.button.button__theme-rackare-b.switch-button {\n  background-color: var(--rackare-background-b-color);\n}\n\n.button.button__theme-rackare-b.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-rackare-b.switch-button .switch-button-item.selected {\n  background-color: var(--rackare-foreground-b-color);\n  color: var(--rackare-background-b-color);\n}\n\n.button.button__theme-rackare-b .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-rackare-b.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--rackare-foreground-b-color);\n}\n\n\n.button.button__theme-rackare-b.inverted.switch-button {\n  background-color: var(--rackare-foreground-b-color);\n}\n\n.button.button__theme-rackare-b.inverted.switch-button .switch-button-item:not(.selected):hover,\n.button.button__theme-rackare-b.inverted.switch-button .switch-button-item.selected {\n  background-color: var(--rackare-background-b-color);\n  color: var(--rackare-foreground-b-color);\n}\n\n.button.button__theme-rackare-b.inverted .switch-button--content:hover .switch-button-item:not(:hover),\n.button.button__theme-rackare-b.inverted.switch-button .switch-button-item {\n  background-color: transparent;\n  color: var(--rackare-background-b-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
